import { apiRawPost } from "./apiClient";

export type ManualInvoiceRequest = {
  recipientName: string;
  email: string;
  phone: string;
  address: string;
  postalCode: string;
  city: string;
  description: string;
  quantity: number;
  unitPrice: number;
  vatRate: number;
  dueAt?: string;
  currency?: string;
  notes?: string;
};

const getFilenameFromDisposition = (contentDisposition: string | null) => {
  if (!contentDisposition) return null;

  const match = /filename\*=UTF-8''([^;]+)|filename="?([^";]+)"?/i.exec(contentDisposition);
  const raw = match?.[1] ?? match?.[2];
  return raw ? decodeURIComponent(raw) : null;
};

export const createManualInvoicePdf = async (request: ManualInvoiceRequest) => {
  const response = await apiRawPost("/api/invoices/manual", request);

  if (!response.ok) {
    const text = await response.text();
    throw new Error(text || `HTTP ${response.status}`);
  }

  const blob = await response.blob();
  const filename = getFilenameFromDisposition(response.headers.get("content-disposition")) ?? "manual-invoice.pdf";

  return { blob, filename };
};
